import { render, staticRenderFns } from "./yearly-expense-item.vue?vue&type=template&id=1f21e366"
import script from "./yearly-expense-item.vue?vue&type=script&lang=js"
export * from "./yearly-expense-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports